import { SerpElement } from "@nosto/preact"
import { collectionHandle, isGiftCollection } from "../config"
import { SkeletonProduct } from "./Skeleton"

export default function Product({ product, pageType }) {
    return (pageType === 'category' ? (
        <li>
            <SerpElement
                as="extended-nosto-card"
                handle={product.url.split('/products/')[1]}
                template="nosto-product-card"
                hit={product}
                ariaLabel={`Product ${product.name}`}
                loading=""
                // adds attributes to shopify's product card
                attr-extend={JSON.stringify({
                    collectionHandle: collectionHandle,
                    isGiftCollection: isGiftCollection,
                    ...(collectionHandle === 'best-sellers' 
                        ? { hideBadges: [{'label': 'Best Seller'}] } 
                        : {}
                    )
                })}
            >
                <SkeletonProduct />
            </SerpElement>
        </li>
    ) : (
        <li>
            <SerpElement
                as="nosto-dynamic-card"
                handle={product.url.split('/products/')[1]}
                template="nosto-product-card"
                hit={product}
                ariaLabel={`Product ${product.name}`}
            >
                <SkeletonProduct />
            </SerpElement>
        </li>
    )
    )
}
